import { render, staticRenderFns } from "./AudioAlert.vue?vue&type=template&id=f38d9d04&"
import script from "./AudioAlert.vue?vue&type=script&lang=js&"
export * from "./AudioAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports